import React from "react"
import { Container, Grid } from "@mui/material"
import TotalsOverview from "./components/TotalsOverview"
import BorrowLimits from "./components/BorrowLimits"
import AccountDetail from "./components/details"

const View = () => {
  return (
    <Container data-test-id='accountOverviewSection' maxWidth='xl'>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={7}>
          <TotalsOverview />
        </Grid>
        <Grid item xs={12} sm={12} md={5}>
          <BorrowLimits />
        </Grid>
      </Grid>
      <AccountDetail />
    </Container>
  )
}

export default View
